import { createEffect } from "effector";
import { restGetUniqueHandler, restPostHandler } from "@utils/rest/RestClient";
import { ActiveUser, AuthResult } from "@type/core/auth/auth.types";
import configuration from "@/utils/Config";
import {
  CasRequestDto,
  CasTicketRequestDto,
} from "@state/auth/dto/request/cas.request.dto";
import { CasUrlResponseDto } from "@state/auth/dto/response/cas.url.response.dto";

const baseUrl = configuration.backendBaseUrl;
const userInfoUrl = baseUrl + "/ws/fo/user";

export const requestGetUserInfo = createEffect({
  handler: restGetUniqueHandler<ActiveUser>(userInfoUrl),
});

export const requestLogin = createEffect({
  handler: restPostHandler<CasTicketRequestDto, AuthResult>(
    configuration.backendBaseUrl + "/auth/cas/login",
  ),
});

export const requestCasURL = createEffect({
  handler: restPostHandler<CasRequestDto, CasUrlResponseDto>(
    configuration.backendBaseUrl + "/auth/login",
  ),
});

export const requestLogout = createEffect({
  handler: restGetUniqueHandler<void>(
    configuration.backendBaseUrl + "/ws/fo/logout",
  ),
});
